import PropTypes from 'prop-types'
import Spinner from 'react-bootstrap/Spinner'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import AdminEBPRoutes from './rutas/AdminEBPRoutes'
import CompradorRoutes from './rutas/CompradorRoutes'
import ComunesRoutes from './rutas/ComunesRoutes'
import PublicRoutes from './rutas/PublicRoutes'
import VendedorRoutes from './rutas/VendedorRoutes'

const ContenedorPrincipal = (props) => {
  const { isAuthenticated, cargandoUsuario } = useAuth()

  if (cargandoUsuario) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '50vh' }}
      >
        <Spinner animation="border" role="status" aria-label="Cargando" />
      </div>
    )
  }

  return (
    <Routes>
      {PublicRoutes(props)}
      {ComunesRoutes(props)}
      {CompradorRoutes(props)}
      {VendedorRoutes(props)}
      {AdminEBPRoutes(props)}
      <Route
        path="*"
        element={<Navigate to={isAuthenticated ? '/Publicaciones' : '/'} replace />}
      />
    </Routes>
  )
}

ContenedorPrincipal.propTypes = {
  cambiarImagenPerfil: PropTypes.func.isRequired
}

export default ContenedorPrincipal
